import styled from "styled-components";
import { Modal } from "react-bootstrap";

export const StyledHeader = styled(Modal.Header)`
  border-bottom: 1px solid #eef0f3;
  padding: 1.25rem 1.5rem;
`;

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.85rem;

  h3 {
    margin: 0;
    font-size: 1.15rem;
    font-weight: 600;
    color: #1f2733;
  }

  span {
    display: block;
    font-size: 0.78rem;
    font-weight: 400;
    color: #8891a0;
    margin-top: 0.15rem;
  }
`;

export const IconCircle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  min-width: 42px;
  border-radius: 50%;
  background: linear-gradient(135deg, #4f7cff 0%, #3a5fe0 100%);
  color: #fff;
`;

export const StyledFooter = styled(Modal.Footer)`
  border-top: 1px solid #eef0f3;
  padding: 1rem 1.5rem;

  button {
    min-width: 100px;
    border-radius: 8px;
    font-weight: 500;
  }
`;

export const WrapperImg = styled.div`
  display: grid;
  justify-content: center;
  align-items: center;

  button {
    border: 1px solid white;
    color: white;
    height: 1.8rem;
  }
`;

export const Wrapper = styled.div`
  margin: 0.25rem 0.5rem 0.75rem;
  display: flex;
  flex-direction: column;
  gap: 0.9rem;

  @media only screen and (min-width: 1100px) {
    display: grid;
    grid-template-columns: 1fr;
    column-gap: 1rem;
    gap: 0.3rem;

    .value-label {
      display: grid;
      grid-template-columns: 1fr 1fr;

      .flex {
        display: flex;
      }
    }

    .initial-value {
      display: grid;
      grid-template-columns: 1fr 1fr;
    }

    .final_value {
      input {
        width: 110px;
      }
    }

    label > .label {
      text-align: right;
      margin-right: 0.5rem;
    }
  }

  .label {
    font-size: 11px;
    font-weight: 500;
    text-align: left;
  }

  label {
    display: grid;
    grid-template-columns: 1fr 3fr;
    text-align: left;

    @media only screen and (max-width: 600px) {
      grid-template-columns: 1fr;
      .label {
        display: none;
      }
    }
  }

  .wrapper-date {
    display: grid;
    grid-template-columns: 1fr;
  }

  .btnAdd {
    width: 100%;
    display: flex;
    justify-content: right;
    margin-top: 1rem;
  }
`;
